<template>
  <div class="detail-event">
    
    <!-- <component-loader :progress="90" :unlimitedProgress="true" v-if="(!(discussion && discussionuser) && !(event.type == 'rating') && !post && !comment)"></component-loader> -->

    <componentDiscussionFacebook v-if="event && event.network == 'facebook' && (event.type == 'message' || event.type == 'message-reaction')"
      :messages="discussion.body && discussion.body.discussion ? discussion.body.discussion : {}"
      :infoConversation="discussion.body && discussion.body.conversation ? discussion.body.conversation : {}"
      :infoUser="discussionuser && discussionuser.body  && discussionuser.body.user ? discussionuser.body.user : {}"
      :event="event"
      :page="page"
      @changeStatus="changeStatus">
    </componentDiscussionFacebook>

    <componentDiscussionInstagram v-else-if="event && event.network == 'instagram' && (event.type == 'message' || event.type == 'message-reaction')"
      :messages="discussion && discussion.body && discussion.body.discussion ? discussion.body.discussion : {}"
      :infoConversation="discussion && discussion.body && discussion.body.conversation ? discussion.body.conversation : {}"
      :infoUser="discussionuser && discussionuser.body && discussionuser.body.user ? discussionuser.body.user : {}"
      :event="event"
      :page="page"
      @changeStatus="changeStatus">
    </componentDiscussionInstagram>
    
    <componentFacebookRating  v-else-if="event && event.type == 'rating' && event.network == 'facebook'" :page="page" :event="event" @changeStatus="changeStatus"></componentFacebookRating>

    <componentPostFacebook v-else-if="event && event.network == 'facebook'" :page="page" :post="post" :event="event" @changeStatus="changeStatus"></componentPostFacebook>
    <componentPostInstagram v-else-if="event && event.network == 'instagram'" :page="page" :post="post" :event="event" @changeStatus="changeStatus"></componentPostInstagram>
    
  </div>
  
</template>

<script>
import moment from 'moment'
import Moderation from './../../mixins/Moderation'
import Tooltip from './../tooltip/tooltipInit'
import PageImageAvatar from './../PageImageAvatar'
import PreviewPost from './../PreviewPost'
import CommentsPost from './../CommentsPost'
import Comment from './../Comment.vue'

import componentDiscussionFacebook from './PrivateDiscussionFacebook'
import componentDiscussionInstagram from './PrivateDiscussionInstagram'
import componentPostFacebook from './PostFacebook'
import componentPostInstagram from './PostInstagram'
import componentFacebookRating from './facebookRating'

import componentLoader from './../overlay/Loader'
import Popup from '../../../utils/Popup'

import emojiData from 'emoji-mart-vue-fast/data/all.json'
import { Picker, EmojiIndex  } from 'emoji-mart-vue-fast'
import 'emoji-mart-vue-fast/css/emoji-mart.css'
import ClickOutside from 'vue-click-outside'

import AvatarComponent from './../utils/avatar.vue'
import SelectComponent from './../utils/select.vue'

export default {
  name: 'component-detail-inbox',

  mixins: [Moderation],

  components: {
    Tooltip,
    PageImageAvatar,
    PreviewPost,
    CommentsPost,
    Comment,
    Picker,
    componentDiscussionFacebook,
    componentDiscussionInstagram,
    componentPostFacebook,
    componentPostInstagram,
    componentFacebookRating,
    componentLoader,
    AvatarComponent,
    SelectComponent
  },

  directives: {
    ClickOutside
  },

  props: {
    page: Object,
    event: Object
  },

  data() {
    return {
      showLoader: false,
      showSelectState: false,

      post: null,
      comment: null,

      message: null,
      showEmojiPicker: false,
      emojiIndex: new EmojiIndex(emojiData),

      showInputComment: false,

      discussion: null,
      discussionuser: null,
    }
  },

  async mounted() {
    if(['message', 'message-reaction'].includes(this.event.type)) {
      this.discussion = {}
      this.discussionuser = null
      this.getDiscussion()
    }else {
      
      await this.getOriginalPost()
      if(this.event.type == 'comment') {
        //await this.getOriginalComment()
        console.log("//getOriginalComment")
      }else this.comment = null
    }

  },

  watch: {
    async event() {
      this.post = {}
      this.comment = null
      this.message = null
      this.discussion = {}
      this.discussionuser = null
      this.showSelectState = false
      if(['message', 'message-reaction'].includes(this.event.type)) {
        this.getDiscussion()
      }else {
        await this.getOriginalPost()
        if(this.event.type == 'comment'){
          //await this.getOriginalComment()
        }
         
      }
   
    }
  },

  methods: {

    getDirectLink(event) {
      let url = `https://www.facebook.com/`
      switch(event.type) {
        case 'rating':
          url = `https://www.facebook.com/${event.data.changes.value.open_graph_story_id}`
          break
        case 'mention':
        case 'message':
        case 'message-reaction':
          url = event.user.link
          break
        case 'status':
          url = `https://www.facebook.com/${event.data.changes.value.post_id}`
          break
        case 'comment':
          url = `https://www.facebook.com/${event.data.changes.value.comment_id}`
          break
      }
      Popup.open(url, '', 900, 700)
    },

    async messageSend(formdata){
      console.log('entrer dans messageSend moderation', this.discussion.data.discussion.data[0].to.data[0].id)
      let recipientId = this.discussion.data.discussion.data[0].from.id != this.page.network_id
                          ? this.discussion.data.discussion.data[0].from.id
                          : this.discussion.data.discussion.data[0].to.data[0].id
      
      await this.sendMessage(this.page, recipientId, formdata)
      await this.getDiscussion()
    },

    async reactToMessage( discussionid, react){
      console.log('entrer dans reactomessage moderation', discussionid)
      console.log('react = ', react)
      let recipientId = this.discussion.data.discussion.data[0].from.id != this.page.network_id
                          ? this.discussion.data.discussion.data[0].from.id
                          : this.discussion.data.discussion.data[0].to.data[0].id

      await this.reactMessage(this.page, recipientId, discussionid, react)
      await this.getDiscussion()
    },

    async getDiscussion(){
      let id = this.event.data.messaging.sender.id != this.event.data.id ? this.event.data.messaging.sender.id : this.event.data.messaging.recipient.id
      
      this.discussion = await this.getDiscussionInbox(this.page, id)

      // if (this.discussion) {
      //   this.discussion = this.discussion.body
      // }

      this.discussionuser = await this.getUser(this.page, id)
    },
    
    hideChangeStatus() {
      if(this.showSelectState) {
        console.log('hideChangeStatus')
        this.showSelectState = false
      }
    },

    getChangeStatus(status=null){
      console.log('getChangeStatus', status, this.event.status)
      if(status == 'waiting') 
        return [0,2].includes(this.event.status) ? this.event.status : (this.event.status == 1 ? '0' : '2')

      else if(status == 'treated') 
        return [1,3].includes(this.event.status) ? this.event.status : (this.event.status == 0 ? '1' : '3')
      
      switch(status || this.event.status){
        case 0:
          return '1'
        case 1:
          return '0'
        case 2:
          return '3'
        case 3:
          return '2'
      }
    },

    hideComment(commentId, is_hidden) {
      this.$emit('hideComment', this.event, commentId, is_hidden)
    },

    submitLike(nodeId) {
      this.$emit('submitLike', this.event._id, nodeId)
    },

    changeEvent(id, body) {
      this.showSelectState = false
      this.$emit('change', id, body)
    },

    changeStatus(status) {
     this.changeEvent(this.event._id, { status: this.getChangeStatus(status)})
    },

    async getOriginalPost() {
      console.log('laaaaa', this.event.type)
      if(this.page.network == 'instagram' && this.event.detail && this.event.detail.mentioned_comment) {


        this.post = {
          id : this.event.detail.id,
          comments : {
            data : [
              this.event.detail.mentioned_comment
            ],
          },
          comments_count : 1,
          like_count : 'n/a',
          media_type : "IMAGE", //Voir si ça varie en fonction des mentions
          media_url:  this.event.detail.mentioned_comment.media.media_url,
          //permalink : this.event.detail.mentioned_comment.media.media_url,
          media_id : this.event.data.changes.value.media_id,
          timestamp : this.event.detail.mentioned_comment.timestamp
        }


        //this.post = this.event.detail.mentioned_comment.media
        //this.comment = this.event.detail.mentioned_comment
        // this.comment.replies.data = this.comment.replies.data.map(d => {
        //   return {
        //     ...d,
        //     from: {
        //       username: d.username
        //     }
        //   }
        // })
      } else if(['post', 'status', 'photo', 'video', 'share', 'comment', 'reaction', 'mention'].includes(this.event.type)) {
        // let postId = this.event.type == 'share' ? this.event.data.changes.value.share_id : this.event.data.changes.value.post_id
        let postId = this.page.network == 'facebook' ? this.event.data.changes.value.post_id : (this.event.data.changes.value.media_id || this.event.data.changes.value.media.id)
        this.getPostFromRS(this.page, postId, true).then(res => {
          console.log('resss get post', res)
          this.showLoader = false
          const { success, error, post } = res.body

          if (!success || success !== true || !post) {
            this.post = false
            return
          }

          this.post = res.body.post
        })
      }else {
        this.post = {}
      }



    },
  },

}    
</script>